var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHighRisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26579 16.2917H7.32693L6.28193 26.1699C6.27734 26.1997 6.2762 26.2879 6.2762 26.3177C6.2762 27.1072 6.91901 27.75 7.70849 27.75C8.15765 27.75 8.58619 27.5346 8.87036 27.153L18.8804 12.8542C19.0648 12.6078 19.1668 12.303 19.1668 11.9948C19.1668 11.2053 18.524 10.5625 17.7345 10.5625H11.5401L12.5714 1.85073C12.5748 1.8175 12.5771 1.71552 12.5771 1.68229C12.5783 0.892812 11.9355 0.25 11.146 0.25C10.6968 0.25 10.2683 0.465417 9.97494 0.858437L1.11995 14C0.935475 14.2464 0.833496 14.5511 0.833496 14.8594C0.833496 15.6488 1.47631 16.2917 2.26579 16.2917Z",
    fill: "#A7A7A9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHighRisk);
export default __webpack_public_path__ + "static/media/icon-high-risk.fb7a662497116675460c8925d654703b.svg";
export { ForwardRef as ReactComponent };